import { type StoreActionApi } from 'react-sweet-state';

import { ceiledIncrement } from './ceiledIncrement';
import { getLastStepOrder } from './getLastStepOrder';
import type { ResearchStep } from './MessageResearch';
import { STARTING_PROGRESS } from './STARTING_PROGRESS';
import type { ChatMessageResearchStore } from './types';

type UpdateStepArgs = {
	messageId: string;
	stepId: string;
	updater: (step: ResearchStep, isNewStep: boolean) => ResearchStep;
};

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const updateStep: (args: UpdateStepArgs) => ChatMessageResearchStoreAction =
	({ messageId, stepId, updater }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const message = getState()[messageId];
		const step = message?.steps[stepId];
		const isNewStep = !step;
		// reuse existing order if the step exists, otherwise create a new one with the next order
		const order = step?.order ?? getLastStepOrder(Object.values(message?.steps ?? {})) + 1;
		const separatedContent = step?.separatedContent ?? [];

		const updatedStep = updater(
			{
				...message?.steps[stepId],
				separatedContent,
				stepId,
				order,
			},
			isNewStep,
		);

		setState({
			[messageId]: {
				...(message ?? { currentProgress: STARTING_PROGRESS }),
				steps: {
					...message?.steps,
					[stepId]: updatedStep,
				},
				// Consider total researchCompleted:false if any step is updated to completed:false
				// This covers any new rounds that may stream in after the others have been completed
				...(!updatedStep.completed ? { researchCompleted: false } : {}),
				...(updatedStep.completed
					? { currentProgress: ceiledIncrement(message?.currentProgress ?? STARTING_PROGRESS) }
					: {}),
			},
		});
	};
